/* global RealGridJS */
// RealGridJS.setRootContext("https://static.wehago.com/realgrid");
RealGridJS.setTrace(false);

export default RealGridJS;